export const blockIconsHardwareLaptopWindowsNew = (
	<span className='material-symbols-outlined'>laptop_windows</span>
);
